module.exports = __webpack_public_path__ + "static/img/1805_8.94f9ea7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1805_8.jpg
// module id = 7+aT
// module chunks = 1